export default __webpack_public_path__ + "assets/images/20b2b68332f0b34711f277097b718cc3.png";